import { Directive, Host, Inject, InjectionToken, OnDestroy } from '@angular/core';
import { SplitbuttonComponent, SplitButtonElement } from '@app/components/elements/splitbutton/splitbutton.component';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { flatten } from 'lodash';

/**
 * 
 */
export const ELEMENT_PROVIDER = new InjectionToken<Observable<SplitButtonElement[]>>('SplitButtonElementProvider');

@Directive({
	selector: '[appElementCollector]',
	exportAs: 'appElementCollector',
})
export class SplitButtonElementsCollectorDirective implements OnDestroy {
	private subscriptions = new Subscription();
	constructor(@Inject(ELEMENT_PROVIDER) providers: Observable<SplitButtonElement[]>[], @Host() splitbutton: SplitbuttonComponent){
		this.subscriptions.add(
			combineLatest(providers)
				.pipe(map(flatten))
				.subscribe(actions => splitbutton.elements = actions)
		);
	}
	
	public ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
